import React from 'react';
import {
  Box,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Toolbar,
  Typography,
} from '@mui/material';
import propTypes from 'prop-types';
import TransactionalQuestionTableHead from './TransactionalQuestionTableHead';

function TransactionalQuestionsSkeleton({ showTitle = true }) {
  return (
    <Box>
      {showTitle && (
        <Stack direction="row" alignItems="center" mb={3}>
          <Typography variant="pageTitle">Transactional Questions</Typography>
          <Skeleton variant="circular" width={20} height={20} sx={{ ml: 1 }} />
        </Stack>
      )}

      <Paper>
        <Toolbar className="border-bottom" sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Box sx={{ width: '20%' }}>
            <Skeleton variant="rectangular" width="auto" height={40} sx={{ borderRadius: 1 }} />
          </Box>
        </Toolbar>

        <TableContainer>
          <Table>
            <TransactionalQuestionTableHead />
            <TableBody>
              {/* Render 3 question groups */}
              {Array.from({ length: 2 }).map((__, groupIndex) => (
                <React.Fragment key={groupIndex}>
                  {/* Group Header Skeleton */}
                  <TableRow sx={{ backgroundColor: 'white' }}>
                    <TableCell colSpan={4}>
                      <Stack direction="row" alignItems="center" gap={2}>
                        <Stack direction="row" alignItems="center" spacing={2}>
                          <Skeleton animation="wave" variant="circular" width={24} height={24} />
                          <Skeleton animation="wave" variant="text" width={300} height={24} />
                        </Stack>
                        <Skeleton animation="wave" variant="text" width={40} height={24} />
                      </Stack>
                    </TableCell>
                  </TableRow>

                  {/* Nested Table Rows - show 2-3 items per group */}
                  {Array.from({ length: groupIndex === 0 ? 1 : 1 }).map((_, itemIndex) => (
                    <TableRow key={`${groupIndex}-${itemIndex}`} hover>
                      <TableCell sx={{ width: { xs: '200px', sm: '40%' }, minWidth: '150px' }}>
                        <Stack gap={0.5}>
                          <Skeleton animation="wave" variant="text" width="70%" height={20} />
                          <Skeleton animation="wave" variant="text" width="50%" height={16} />
                        </Stack>
                      </TableCell>
                      <TableCell sx={{ width: { xs: '150px', sm: '20%' }, minWidth: '120px' }}>
                        <Skeleton animation="wave" variant="text" width="60%" height={20} />
                      </TableCell>
                      <TableCell sx={{ width: { xs: '150px', sm: '20%' }, minWidth: '120px' }}>
                        <Skeleton animation="wave" variant="text" width="60%" height={20} />
                      </TableCell>
                      <TableCell sx={{ width: { xs: '200px', sm: '40%' }, minWidth: '150px' }}>
                        <Stack gap={1} alignItems="flex-start">
                          <Skeleton animation="wave" variant="text" width="90%" height={20} />
                          <Skeleton animation="wave" variant="text" width="80%" height={20} />
                          <Skeleton animation="wave" variant="rounded" width={200} height={32} />
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}

TransactionalQuestionsSkeleton.propTypes = {
  showTitle: propTypes.bool,
};

export default TransactionalQuestionsSkeleton;
